import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';
import * as React from 'react';

const ignoredExportClasses = [
    "spending-chart-export",
    "zoomhelp",
    "zoomhelpmap",
    "zoomhelpcongressmap",
];

export async function exportSpendingReportChart(targetId: string, fileName: string) {
    const element = document.getElementById(targetId);
    if (!element) return;

    const isMapExport = element.classList.contains("spending-export-block--map");
    const isCongressExport = element.classList.contains("spending-export-block--congress");
    const applyExportStylesOnClone = !isMapExport;

    await html2canvas(element, {
        useCORS: true,
        backgroundColor: "#ffffff",
        ignoreElements: (node) => {
            if (!(node instanceof HTMLElement)) return false;
            return ignoredExportClasses.some((className) => node.classList.contains(className));
        },
        onclone: (_clonedDoc, clone) => {
            if (applyExportStylesOnClone) {
                clone.classList.add("is-exporting");
            }
        }
    }).then(canvas => {
        const padding = Math.round(canvas.width * (isMapExport ? 0.04 : 0.06));
        const paddingRight = isMapExport
            ? Math.round(canvas.width * (isCongressExport ? 0.06 : 0.04))
            : Math.round(canvas.width * 0.12);
        const paddingVertical = Math.round(canvas.height * (isMapExport ? 0.04 : 0.06));
        const centeredCanvas = document.createElement("canvas");
        centeredCanvas.width = canvas.width + padding + paddingRight;
        centeredCanvas.height = canvas.height + paddingVertical * 2;

        const ctx = centeredCanvas.getContext("2d");
        if (!ctx) return;

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, centeredCanvas.width, centeredCanvas.height);
        ctx.drawImage(canvas, padding, paddingVertical);

        centeredCanvas.toBlob(blob => {
            if (blob) {
                saveAs(blob, fileName);
            }
        });
    });
}

export function getSpendingReportYearLabel(start_year?: string | number, end_year?: string | number) {
    if (start_year == null || end_year == null) return "";
    return start_year == end_year ? `${start_year}` : `${start_year}-${end_year}`;
}

export function SpendingReportExportLink({ targetId, fileName }: { targetId: string; fileName: string }) {
    return (
        <a
            className="spending-chart-export"
            onClick={() => exportSpendingReportChart(targetId, fileName)}
        >
            <i className="fa fas fa-download ecr_export"></i>EXPORT CHART
        </a>
    );
}
